export default __webpack_public_path__ + "static/media/rug1-min.ba2fc1f2.jpg";